<template>
  <div class="project-create">
    <div class="manage-wrapper">
      <span class="goBack" @click="goBack">返回</span>
      <div class="project-create-container">
        <iframe :src='$route.query.iframeUrl' width='100%' height='700' frameborder='0' style='overflow:auto'></iframe>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    mapState
  } from "vuex";
  export default {
    data() {
      return {
      };
    },
    computed: {
      ...mapState({
        role: state => state.user.role,
        roleId: state => state.user.roleId,
      })
    },
    methods: {
      goBack() {
        // 专家、管理员返回manage/wjx，参训教师返回/home/WjxTeaList
        // console.log('当前角色:', this.role, '角色id:', this.roleId)
        if (this.roleId == 356 || this.roleId == 123) {
          this.$router.push('/home/manage/wjx')
        } else {
          this.$router.push('/home/WjxTeaList')
        }
      }
    },
    mounted() {
      console.log(this.$route.query.iframeUrl);
      this.$route.meta.title = this.$route.query.breadcrumbName
    }
  };
</script>

<style lang="less" scoped>
  .goBack {
    cursor: pointer;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
    color: #409EFF;
  }
</style>